module.exports = __webpack_public_path__ + "static/media/garage-regular.cdf795e1.jpg";